import { Button, Group, Menu } from "@mantine/core";
import React, { useState } from "react";
import { IconChevronDown } from "@tabler/icons";
import { useServerApi } from "../hooks/userServerApi";
import { useTranslation } from "react-i18next";
import QuotationConfirmButton from "./quotationConfirmButton";
import QuotationCopyDNButton from "./quotationCopyDNButton";
import ActionPermissionGate from "./actionPermissionGate";
import { saveFormFields } from "../helpers/formFieldSave";
import { openFileUrl } from "../utils/openReport";

const QuotationPrintDropdown = ({
  mainForm,
  disabled = false,
  type = "QUO",
}) => {
  const [api] = useServerApi();
  const [printing, setPrinting] = useState(false);
  const { t: translate } = useTranslation();

  const print = async (format) => {
    try {
      const { _id } = mainForm.values;
      if (!_id) return;

      setPrinting(true);
      const result = await api.Quotation.print(_id, type, format);
      if (!result || !result.data || !result.data.url) return;
      await openFileUrl(result.data.url);
      mainForm.setFieldValue("status", result.data.status);
      mainForm.notifyListRefresh?.();
    } catch (error) {
      console.log(error);
    } finally {
      setPrinting(false);
    }
  };

  return (
    <Menu shadow="md" width={200} withinPortal>
      <Menu.Target>
        <Button
          fullWidth
          color="teal"
          disabled={disabled}
          loading={printing}
          rightIcon={<IconChevronDown size={16} />}
          styles={{
            inner: { position: "relative", justifyContent: "center" },
            label: {
              flex: 1,
              width: "100%",
              justifyContent: "center",
              paddingRight: 28,
            },
            rightIcon: {
              position: "absolute",
              right: 12,
              top: "50%",
              transform: "translateY(-50%)",
              marginLeft: 0,
            },
          }}
        >
          {printing ? translate("Printing") : translate("Quotation")}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={() => print("pdf")} disabled={printing || disabled}>
          PDF
        </Menu.Item>
        <Menu.Item onClick={() => print("word")} disabled={printing || disabled}>
          Word
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

const OuotationTerminateButton = ({ mainForm, disabled = false }) => {
  const { t } = useTranslation();

  const terminate = () => {
    saveFormFields(mainForm, { status: "CAN" });
  };

  return (
    <Button
      fullWidth
      disabled={disabled}
      color={"red"}
      onClick={() => terminate()}
    >
      {t("Cancel")}
    </Button>
  );
};

const QuotationActionList = ({ form }) => {
  const { _id } = form.values;
  const disabled = !_id;

  return (
    <Group mt={10}>
      <ActionPermissionGate
        entity="quotation"
        action="printQuotation"
        requireFullAccess={false}
      >
        <QuotationPrintDropdown mainForm={form} disabled={disabled} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="quotation" action="confirmQuotation">
        <QuotationConfirmButton mainForm={form} disabled={disabled} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="quotation" action="copyToDebitNote">
        <QuotationCopyDNButton
          mainForm={form}
          title="Confirm & Generate Debit Note"
          color="green"
          disabled={disabled}
        />
      </ActionPermissionGate>

      <ActionPermissionGate entity="quotation" action="cancelQuotation">
        <OuotationTerminateButton mainForm={form} disabled={disabled} />
      </ActionPermissionGate>
    </Group>
  );
};

export default QuotationActionList;
